import calculateField from '../../../components/formBuilder/utility/calculateFields';

//this function uses the projections schema to loop through and calculate the values for each year. the field.valueType determines how the value is calculated, unless the field has a calcFunction, in which case that function is called to calculate the value
export const projectionCalculator = (
  years,
  fieldSchema,
  data,
  offsetYears = 0
) => {
  const result = [];

  // valueType: 'yearSpreadDollar',
  // spreader: 'rehabLengthGreater12',
  // condition: 'rehabGreater12'
  const basicValuesSchema = fieldSchema.filter((field) => !field.calcFunction);
  const calculatedValuesSchema = fieldSchema.filter(
    (field) => field.calcFunction
  );

  const incomeIncrease = data.yearlyIncomeIncrease / 100 + 1 || 1;
  const expensesIncrease = data.yearlyExpenseIncrease / 100 + 1 || 1;
  const passiveAppreciation = data.marketAppreciationPercent / 100 + 1 || 1;
  const vacancyRate =
    data.vacancy /
    (data.rentalIncomePreVacancy || data.totalRentalIncomeBuyAndHold || 0);

  for (let year = 1; year <= years - offsetYears; year++) {
    const yearData = {
      yearName: `Year ${year + offsetYears}`,
      year,
    };

    const previousYear = result[year - 2] || null;

    for (const field of basicValuesSchema) {
      const value = data[field.name];

      switch (field.valueType) {
        case 'monthlyDollar':
        case 'yearlyDollar':
          if (field.returnNull) {
            if (data[field.returnNull]) {
              yearData[field.name] = null;
              break;
            }
          }

          let baseValue = previousYear ? previousYear[field.name] : value;

          switch (field.multiplier) {
            case 'incomeIncrease':
              yearData[field.name] = baseValue * incomeIncrease;
              break;
            case 'expensesIncrease':
              yearData[field.name] = baseValue * expensesIncrease;
              break;
            case 'passiveAppreciation':
              yearData[field.name] = baseValue * passiveAppreciation;
              break;
            default:
              yearData[field.name] = baseValue;
          }

          if (previousYear) {
            if (field.subtractor) {
              yearData[field.name] = baseValue - previousYear[field.subtractor];
            }
          } else {
            yearData[field.name] =
              field.valueType === 'monthlyDollar'
                ? (yearData[field.name] || value) * 12
                : yearData[field.name] || value;
          }

          break;

        case 'oneTimeDollar':
          if (year === 1) {
            yearData[field.name] = value;
          } else {
            yearData[field.name] = 0;
          }
          break;

        //this is a specific implementation to account for multiple year rehabs, dividing the increase in value by the number of years
        case 'yearSpreadDollar':
          if (
            data[field.spreader] / 12 > 0 &&
            Math.floor(data[field.spreader] / 12) > 0
          ) {
            const spreadYears = Math.floor(data[field.spreader] / 12);
            const spreadMonths = data[field.spreader] % 12;

            if (year <= spreadYears) {
              yearData[field.name] = (value / data[field.spreader]) * 12;
            }
            if (year === spreadYears + 1) {
              yearData[field.name] =
                (value / data[field.spreader]) * spreadMonths;
            }
            if (year > spreadYears + 1) {
              yearData[field.name] = 0;
            }
          } else {
            if (year === 1) {
              yearData[field.name] = value;
            } else {
              yearData[field.name] = 0;
            }
          }
          break;

        case 'constantPercent':
          yearData[field.name] = value;
          break;
      }
    }

    for (const field of calculatedValuesSchema) {
      try {
        const calculated = calculateField(field, {
          ...previousYear,
          ...data,
          ...yearData,
          vacancyRate,
        });

        yearData[field.name] = calculated;
      } catch (e) {
        console.error('Error calculating field', field.name, e);
      }
    }

    result.push(yearData);
  }
  return result;
};
